import React from 'react';
import { Box, StyleSystemProps } from '@withjoy/joykit';
import { useCatalogCurationHeroController } from './CatalogCurationHero.controller';
import { HeroSlider, HeroSliderProps } from '../../../../CatalogProductsIndex/components/ShopHeroSlider';

export interface CatalogCurationHeroProps {
  skipStaticHero?: boolean;
  skipServerHeros?: boolean;
  onViewCollectionClick?: HeroSliderProps['onViewCollectionClick'];
  customWrapperStyles?: StyleSystemProps;
}

export const CatalogCurationHero: React.FC<CatalogCurationHeroProps> = (props = {}) => {
  const { loading, curations, handleOnViewCollectionClick, handleOnOpenVideoPlayer } = useCatalogCurationHeroController(props);
  return (
    <Box marginBottom={0}>
      <HeroSlider
        items={curations ?? []}
        loading={loading}
        onViewCollectionClick={handleOnViewCollectionClick}
        onOpenVideoPlayer={handleOnOpenVideoPlayer}
        customWrapperStyles={props.customWrapperStyles}
      />
    </Box>
  );
};
